import React from 'react';
import { ReactComponent as IconSvg } from './delete.svg';
const DeleteSvg = ({ className }) => React.createElement(IconSvg, { className: className });
export default DeleteSvg;
